module.exports = __webpack_public_path__ + "static/img/header_bg2.34de628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/header/header_bg2.png
// module id = MPgv
// module chunks = 4